import { Navigate, Outlet, useParams } from 'react-router-dom'
import { Routes } from 'routes'
import styled from 'styled-components'
import { Spinner } from '@/ui/components'
import { useAuthenticationState } from '@/ui/core/hooks'

const StyledSpinner = styled(Spinner)`
  max-width: 100px;
  max-height: 100px;
  color: ${({ theme }) => theme.colors.brand.primary.active};
`

export const AuthLayout: React.FC = () => {
  const { eventId } = useParams()
  const { isSignedIn, loadingAuthState, checkAuthStateError } =
    useAuthenticationState()

  const navigateToAuth = checkAuthStateError || !isSignedIn

  return loadingAuthState ? (
    <StyledSpinner />
  ) : navigateToAuth && eventId ? (
    <Navigate to={`${Routes.authentication}?dest=${eventId}`} />
  ) : navigateToAuth ? (
    <Navigate to={Routes.authentication} />
  ) : (
    <Outlet />
  )
}
